import type { FC, ReactNode } from "react"

interface TwoColumnLayoutProps {
  sidebar: ReactNode
  content: ReactNode
}

const TwoColumnLayout: FC<TwoColumnLayoutProps> = ({ sidebar, content }) => {
  return (
    <div className="flex gap-4">
      {sidebar}
      <div className="flex flex-1 flex-col">{content}</div>
    </div>
  )
}

export default TwoColumnLayout
